import { STATUSPAGE } from '@repo/ui';
import {
  GetUsersOnlineInterface,
  GetUsersOnlineMapsInterface,
} from 'domain/usecases';
import { notifyError } from 'presentation/app/components/notify';
import { useService } from 'presentation/app/hooks/useService';
import { loadUsersOnlineListData } from 'presentation/config/store/users/users-online/users-online-slice';
import { useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

export const useUsersOnline = () => {
  // hooks
  const { usersService } = useService();

  const dispatch = useDispatch();

  // states
  const [userOnlineStatus, setUserOnlineStatus] = useState<STATUSPAGE>(
    STATUSPAGE.DONE,
  );

  const [userOnlineMapsStatus, setUserOnlineMapsStatus] = useState<STATUSPAGE>(
    STATUSPAGE.DONE,
  );

  const [listUsersOnline, setListUsersOnline] =
    useState<GetUsersOnlineInterface.Result>();

  const [listUsersOnlineMaps, setListUsersOnlineMaps] =
    useState<GetUsersOnlineMapsInterface.Result>();

  const requestUsersOnline = useCallback(
    async (params?: GetUsersOnlineInterface.Params) => {
      setUserOnlineStatus(STATUSPAGE.LOADING);
      return usersService
        .getUsersOnline(params)
        .then((res) => {
          setListUsersOnline(res);
        })
        .catch((err) => {
          notifyError(err.message || 'Erro ao listar usuários online');
        })
        .finally(() => {
          setUserOnlineStatus(STATUSPAGE.DONE);
        });
    },
    [],
  );

  const requestUsersOnlineMaps = useCallback(
    async (params: GetUsersOnlineMapsInterface.Params) => {
      setUserOnlineMapsStatus(STATUSPAGE.LOADING);
      return usersService
        .getUsersOnlineMaps(params)
        .then((res) => {
          setListUsersOnlineMaps(res);
        })
        .catch((err) => {
          notifyError(
            err.message || 'Erro ao carregar o mapa de usuários online',
          );
        })
        .finally(() => {
          setUserOnlineMapsStatus(STATUSPAGE.DONE);
        });
    },
    [],
  );

  const requestUsersOnlineHeaders = useCallback(
    async (params?: GetUsersOnlineInterface.Params) => {
      return usersService
        .getUsersOnline(params)
        .then((res) => {
          dispatch(loadUsersOnlineListData(res));
        })
        .catch((err) => {});
    },
    [],
  );

  return {
    requestUsersOnline,
    requestUsersOnlineMaps,
    requestUsersOnlineHeaders,
    listUsersOnline,
    listUsersOnlineMaps,
    userOnlineStatus,
    userOnlineMapsStatus,
  };
};
